import { render, staticRenderFns } from "./CurdPanel.vue?vue&type=template&id=79709790&"
import script from "./CurdPanel.vue?vue&type=script&lang=js&"
export * from "./CurdPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports